import { Component, OnInit, Inject } from '@angular/core';
import { inject } from '@angular/core/testing';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BookmarkTemplateService } from '../../../services/bookmark-template.service';

@Component({
    selector: 'app-document-template-dialog',
    template: require('./document-template-dialog.component.html'),
    styles: [require('./document-template-dialog.component.css')]
})
export class DocumentTemplateDialogComponent implements OnInit {

    applicantForm: FormGroup = new FormGroup({});

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<DocumentTemplateDialogComponent>,
        private fb: FormBuilder, private bookmarkTemplateService: BookmarkTemplateService
    ) { }

    ngOnInit() {

        this.applicantForm = this.fb.group({
            name: ["", Validators.required],
            documentTemplatePath: [null],
            documentType: [null,Validators.required],
            emailSubject: [null],
            emailtemplatePath: [null],
            documentBookmarksJson: [null],
            emailBookmarksJson: [null],
        })
    }

    close() {
        this.dialogRef.close();
    }

    onSave() {
        console.log(this.applicantForm)
        if (!this.applicantForm.valid) {
            return;
        } else {
            this.bookmarkTemplateService.createDocumentTemplate(this.applicantForm.value).subscribe(r => {
                console.log(r)
                this.dialogRef.close(r)
            })
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/bookmark-templates/document-template-dialog/document-template-dialog.component.ts